import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//Servicios
import { AuthorizeGuard } from './services/authorize-guard.service';
import { AuthorizeGuardNoTokenService } from './services/authorize-guard-no-token.service';
import { AuthorizeGuardAllowService } from 'src/app/services/authorize-guard-allow.service';

//Componentes
import { MegaComponent } from './components/home/mega/mega.component';
import { OlvidoContrasenaComponent } from './components/olvido-contrasena/olvido-contrasena.component';
import { CambiarContrasenaComponent } from './components/cambiar-contrasena/cambiar-contrasena.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { HomeComponent } from './components/home/home.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { LoginComponent } from './components/login/login.component';

//1 admin, 2 hostelero, 3 consumidor, 4 root

const routes: Routes = [
  {path: '', component: WelcomeComponent},
  {path: 'login', component: LoginComponent},
  {path: 'olvido-contraseña', component: OlvidoContrasenaComponent, canActivate: [AuthorizeGuardNoTokenService]},
  {path: 'cambiar-contraseña', component: CambiarContrasenaComponent, canActivate: [AuthorizeGuardAllowService]},
  {path: 'perfil', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'mega', component: MegaComponent, canActivate: [AuthorizeGuard]},
  {path: 'home', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'home/establecimientos', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'establecimientos', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'establecimientos/agregar', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'establecimiento/:id', component:HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'establecimiento/ver/:id', component:HomeComponent, canActivate: [AuthorizeGuard]},
  {path: ':id/editar/establecimiento', component:HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'establecimientos/mapa', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'establecimientos/alarmas', component: HomeComponent, canActivate: [AuthorizeGuard]},
  //{path: 'dispositivo/:id', component:HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'dispositivo/ver/:id', component:HomeComponent, canActivate: [AuthorizeGuard]},
  {path: ':id/editar/dispositivo', component:HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'dispositivos', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'dispositivos/agregar', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'alarmas/activas', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'alarmas/historial', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'configuracion/alarmas', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'tanques', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'tanques/agregar', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'tanques/:id/editar', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'tanque/:id', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'pedido/agregar', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'pedidos', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'recargas/historial', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'cervezas/agregar', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'cervezas/:id/editar', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'cerveza/:id', component:HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'cervezas', component: HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'clientes', component: HomeComponent, canActivate: [AuthorizeGuard] },
  {path: 'clientes/agregar', component: HomeComponent, canActivate: [AuthorizeGuard] },
  {path: 'clientes/:id/editar', component:HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'usuarios', component: HomeComponent, canActivate: [AuthorizeGuard] },
  {path: 'usuarios/agregar', component: HomeComponent, canActivate: [AuthorizeGuard] },
  {path: 'usuarios/:id/editar', component:HomeComponent, canActivate: [AuthorizeGuard]},
  {path: 'estadisticas', component: HomeComponent, canActivate: [AuthorizeGuard] },
  {path: 'estadisticas/consumo', component: HomeComponent, canActivate: [AuthorizeGuard] },
  {path: 'canalejas', component: HomeComponent, canActivate: [AuthorizeGuard] },
  {path: '**', component: PageNotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [AuthorizeGuard],
  exports: [RouterModule]
})
export class AppRoutingModule { }
